import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";


ChartJS.register(ArcElement, Tooltip, Legend);

const LoggedHoursChart = ( {loggedHours} : any) => {
  const maxHours = 8;
  const remainingHours = maxHours - loggedHours;

  const data = {
    labels: ["Logged Hours", "Remaining Hours"],
    datasets: [
      {
        data: [loggedHours, remainingHours],
        backgroundColor: ["#CEC946", "#BDBDBD"],
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        enabled: false, 
      },
      legend: {
        display: false, 
      },
    },
    cutout: "60%", 
  };

  const formatToHHMM = (hour: number) => {
    if (typeof hour !== 'number' || hour < 0) return 'Invalid input';
    
    const hours = Math.floor(hour);
    const minutes = Math.round((hour - hours) * 60);

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }


  return (
    <div className="flex items-center justify-between space-x-4">
      <p className="text-sm font-medium">
        Total logged hours today:{" "}
        <span className="font-semibold">{formatToHHMM(loggedHours)}</span>
      </p>
      <div className="w-20 h-18">
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

export default LoggedHoursChart;
